(() => {
  if (window.__thbDiscoveryLoaded) return;
  window.__thbDiscoveryLoaded = true;
  const key = 'thb:v2:favorites';
  let records = [];
  const safePath = value => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin && /\/products\/[^/]+$/.test(url.pathname) ? url.pathname + url.search : ''; } catch { return ''; }
  };
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      records = Array.isArray(data) ? data.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && safePath(item.url)).slice(-200) : [];
    } catch { records = []; }
  };
  const dialogs = () => [...document.querySelectorAll('[data-thb-favorites]')];
  const announce = (message, error = false) => {
    document.querySelectorAll('[data-thb-favorites-status],[data-thb-favorites-announcement]').forEach(el => { el.textContent = message; });
    if (error && !dialogs().some(dialog => dialog.open)) {
      const button = document.querySelector('[data-thb-favorites-open]');
      if (button) open(button);
    }
  };
  const paint = () => {
    document.querySelectorAll('[data-v2-wishlist]').forEach(button => {
      button.hidden = false; button.setAttribute('aria-pressed', String(records.some(item => item.id === button.dataset.productId)));
    });
    document.querySelectorAll('[data-thb-favorites-open]').forEach(button => button.hidden = false);
    document.querySelectorAll('[data-thb-favorites-count]').forEach(el => { el.textContent = records.length; el.hidden = !records.length; });
    dialogs().forEach(dialog => {
      const list = dialog.querySelector('[data-thb-favorites-list]');
      const rows = [...list.children];
      const focused = document.activeElement;
      const focusedIndex = rows.findIndex(row => row.contains(focused));
      const focusedSelector = focused?.matches('a') ? 'a' : 'button';
      const existing = new Map(rows.map(row => [row.querySelector('[data-thb-favorite-remove]')?.dataset.thbFavoriteRemove, row]));
      const nextRows = records.map(item => {
        const row = existing.get(item.id) || document.createElement('li');
        const link = row.querySelector('a') || document.createElement('a');
        const button = row.querySelector('button') || document.createElement('button');
        link.href = safePath(item.url); link.textContent = item.title;
        button.type = 'button'; button.dataset.thbFavoriteRemove = item.id; button.textContent = dialog.dataset.removeLabel;
        button.setAttribute('aria-label', dialog.dataset.removeLabel + ': ' + item.title);
        if (!row.children.length) row.append(link, button);
        return row;
      });
      const retained = new Set(nextRows);
      rows.forEach(row => { if (!retained.has(row)) row.remove(); });
      nextRows.forEach((row, index) => { if (list.children[index] !== row) list.insertBefore(row, list.children[index] || null); });
      dialog.querySelector('[data-thb-favorites-empty]').hidden = records.length > 0;
      if (focusedIndex >= 0 && dialog.open && document.activeElement !== focused) {
        const target = focused.isConnected ? focused : nextRows[Math.min(focusedIndex, nextRows.length - 1)]?.querySelector(focusedSelector) || dialog.querySelector('[data-thb-favorites-close]');
        target?.focus({preventScroll: true});
      }
    });
  };
  const persist = next => {
    try { localStorage.setItem(key, JSON.stringify(next)); records = next; paint(); return true; }
    catch { announce(dialogs()[0]?.dataset.errorLabel || '', true); return false; }
  };
  const triggers = new WeakMap();
  const open = button => {
    const dialog = document.getElementById(button.getAttribute('aria-controls'));
    if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;
    triggers.set(dialog, button); window.THBModalScroll?.lock(dialog);
    try { dialog.showModal(); } catch { window.THBModalScroll?.unlock(dialog); }
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-thb-favorites-open]');
    if (trigger) { paint(); open(trigger); return; }
    const wish = event.target.closest('[data-v2-wishlist]');
    if (wish) {
      const id = wish.dataset.productId, url = safePath(wish.dataset.productUrl), title = wish.dataset.productTitle;
      if (!id || !url || !title) return;
      read();
      const exists = records.some(item => item.id === id);
      const next = exists ? records.filter(item => item.id !== id) : [...records, {id, url, title}].slice(-200);
      if (persist(next)) announce(dialogs()[0]?.dataset[exists ? 'removedLabel' : 'savedLabel'] || '');
    }
    const remove = event.target.closest('[data-thb-favorite-remove]');
    if (remove) {
      const dialog = remove.closest('dialog');
      read();
      if (persist(records.filter(item => item.id !== remove.dataset.thbFavoriteRemove))) announce(dialog?.dataset.removedLabel || '');
    }
    event.target.closest('[data-thb-favorites-close]')?.closest('dialog')?.close();
    if (event.target.matches?.('[data-thb-favorites]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (!event.target.matches?.('[data-thb-favorites]')) return;
    window.THBModalScroll?.unlock(event.target); triggers.get(event.target)?.focus({preventScroll: true});
  }, true);
  const fitDropdowns = () => {
    document.querySelectorAll('.thb-header--v2 .thb-header__nav-details[open] > .thb-header__dropdown').forEach(panel => {
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.offsetTop + viewport.height : innerHeight;
      panel.style.maxHeight = Math.max(0, bottom - (panel.parentElement.getBoundingClientRect().bottom + 1) - 8) + 'px';
      panel.style.overflowY = 'auto';
    });
  };
  let navigationFocus;
  document.addEventListener('focusin', event => {
    navigationFocus = event.target.closest?.('.thb-header--v2 .thb-header__nav') ? event.target : null;
  });
  window.addEventListener('resize', () => {
    if (innerWidth >= 1200 || !navigationFocus) return;
    const header = navigationFocus.closest('.thb-header--v2');
    const restoreFocus = document.activeElement === document.body || document.activeElement === navigationFocus;
    header?.querySelectorAll('.thb-header__nav-details[open]').forEach(details => details.open = false);
    if (restoreFocus) header?.querySelector('.thb-header__mobile-trigger')?.focus({preventScroll: true});
    navigationFocus = null;
  });
  document.addEventListener('toggle', fitDropdowns, true);
  window.addEventListener('resize', fitDropdowns);
  window.addEventListener('scroll', fitDropdowns, {passive: true});
  window.visualViewport?.addEventListener('resize', fitDropdowns);
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { read(); paint(); } });
  document.addEventListener('shopify:section:load', () => { paint(); fitDropdowns(); });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-thb-favorites][open]').forEach(dialog => { dialog.close(); window.THBModalScroll?.unlock(dialog); });
  });
  read(); paint(); fitDropdowns();
})();
